import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FooterSection = ({ scrollToSection }) => {
  const navigate = useNavigate();
  
  const navItems = [
    { label: '¿Qué es Kompa?', id: 'que-es-kompa' },
    { label: 'Modalidades', id: 'ahorro-con-proposito' },
    { label: 'Planes', id: 'planes' },
    { label: 'FAQ', id: 'faq' },
  ];

  return (
    <footer id="footer" className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <motion.div
          animate={{ scale: [1, 1.5, 1], opacity: [0.05, 0.1, 0.05] }}
          transition={{ duration: 10, repeat: Infinity }}
          className="absolute top-0 right-0 w-96 h-96 bg-orange-500 rounded-full blur-3xl"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2 lg:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_cb23de51-57d5-4133-8f16-28731c09c0ec/artifacts/55wsaotk_KOMPA%206.png"
              alt="KOMPA"
              className="h-16 mb-4"
            />
            <p className="text-blue-100 mb-4 text-xl font-bold">Activa tus metas</p>
            <p className="text-blue-200 mb-6 text-lg">
              La primera plataforma de finanzas personales con propósito hecha en Venezuela.
            </p>
            <div className="flex space-x-4">
              {['f', 'in', 'ig'].map((social, i) => (
                <motion.a
                  key={i}
                  href="#"
                  whileHover={{ scale: 1.1, y: -5 }}
                  className="w-12 h-12 bg-white/10 hover:bg-orange-500 rounded-full flex items-center justify-center transition-all duration-300"
                >
                  <span className="font-bold text-lg">{social}</span>
                </motion.a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-black text-xl mb-6">Enlaces rápidos</h4>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-blue-200 hover:text-orange-400 transition-colors font-medium"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-black text-xl mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-orange-400" />
                <span className="text-blue-200">+58 412 123 4567</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-orange-400" />
                <span className="text-blue-200">hola@kompa.com.ve</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={20} className="text-orange-400" />
                <span className="text-blue-200">Caracas, Venezuela</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-black text-xl mb-6">Inversores</h4>
            <motion.button
              onClick={() => navigate('/investor-login')}
              whileHover={{ scale: 1.05 }}
              className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-all duration-300"
            >
              Portal de Inversores
            </motion.button>
          </div>
        </div>

        <div className="border-t border-blue-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a href="#" className="text-blue-200 hover:text-white transition-colors">
                Términos y condiciones
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors">
                Políticas de privacidad
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors">
                Información legal
              </a>
            </div>
            <p className="text-blue-200 text-sm">
              © 2025 KOMPA. Todos los derechos reservados.
            </p>
          </div>
          <p className="text-blue-300 text-xs mt-6 text-center">
            KOMPA es una plataforma de planificación y ahorro con propósito. No somos un banco tradicional.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
